/**
 * Created by linjianxi on 2016/10/29.
 */
import * as actions from './actions'
import * as getters from './getter'
import * as types from './mutation-type'

const state = {
  time: 60,
  isShow: true,
  contextid: null,
  isYes: false,
  isAct: true
}
const mutations = {
  [types.COUNT_DOWN] (state, params) {
    state.time = params.time
    state.isShow = params.isShow
    state.contextid = params.result.contextid
    state.isYes = params.isYes
    state.isAct = params.isAct
  },
  [types.TIME_COUNT] (state, params) {
    state.isAct = params.isAct
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/card_bind/store.js